"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Plot = void 0;
const rc_js_util_1 = require("rc-js-util");
const plot_dimensions_1 = require("./plot-dimensions");
const event_service_1 = require("../eventing/event-service");
const on_entity_removed_1 = require("./events/on-entity-removed");
const on_entity_added_1 = require("./events/on-entity-added");
const on_entity_added_to_group_1 = require("./events/on-entity-added-to-group");
const on_entity_removed_from_group_1 = require("./events/on-entity-removed-from-group");
/**
 * @public
 * {@inheritDoc IPlot}
 */
class Plot {
    constructor(arg) {
        var _a;
        this.eventService = new event_service_1.EventService();
        this.onCanvasResized = () => {
            this.setPlotArea(this.plotDimensionsOBL.clipSpaceArea);
        };
        this.interactionHandler = null;
        this.entities = new Set();
        this.entitiesByGroup = new Map();
        this.groupsByEntities = new Map();
        this.changeIdFactory = arg.chart.changeIdFactory;
        this.plotRange = arg.plotOptions.plotRange;
        this.plotName = (_a = arg.plotOptions.plotName) !== null && _a !== void 0 ? _a : null;
        this.chartEventService = arg.chart.eventService;
        this.attachPoint = arg.chart.attachPoint;
        this.plotDimensionsOTL = plot_dimensions_1.PlotDimensions.createOneOTL(arg.plotArea, this.attachPoint.canvasDims);
        this.plotDimensionsOBL = plot_dimensions_1.PlotDimensions.createOneOBL(arg.plotArea, this.attachPoint.canvasDims);
        this.updateStrategy = arg.plotOptions.createUpdateStrategy(this, arg.plotOptions.updateGroup);
    }
    static getChartEventService(plot) {
        return plot.chartEventService;
    }
    getInteractionHandler() {
        return this.interactionHandler;
    }
    setInteractionHandler(interactionHandler, getTargetProviders, initialStateProvider) {
        this.clearInteractionHandler();
        this.interactionHandler = interactionHandler;
        return this.interactionHandler.register(this, this.chartEventService, getTargetProviders, initialStateProvider);
    }
    clearInteractionHandler() {
        if (this.interactionHandler != null) {
            this.interactionHandler.unregister(this.chartEventService);
            this.interactionHandler = null;
        }
    }
    setPlotArea(plotClipSpaceArea) {
        this.plotDimensionsOTL = plot_dimensions_1.PlotDimensions.createOneOTL(plotClipSpaceArea, this.attachPoint.canvasDims);
        this.plotDimensionsOBL = plot_dimensions_1.PlotDimensions.createOneOBL(plotClipSpaceArea, this.attachPoint.canvasDims);
    }
    addEntity(entity) {
        if (this.entities.has(entity)) {
            return;
        }
        if (entity.changeId === -1) {
            entity.changeId = this.changeIdFactory.getNextId();
        }
        this.entities.add(entity);
        on_entity_added_1.OnEntityAdded.emit(this.eventService, entity);
        on_entity_added_1.OnEntityAdded.emit(this.chartEventService, entity);
    }
    removeEntity(entity) {
        const removedEntity = this.entities.delete(entity);
        if (!removedEntity) {
            return;
        }
        const groups = this.groupsByEntities.get(entity);
        if (groups != null) {
            groups.forEach(group => {
                const entities = this.entitiesByGroup.get(group);
                if (entities != null) {
                    DEBUG_MODE && rc_js_util_1._Debug.assert(entities.has(entity), "expected entity to be in group");
                    entities.delete(entity);
                    group.onEntityRemoved(entity);
                    on_entity_removed_from_group_1.OnEntityRemovedFromGroup.emit(this, entity, group);
                }
            });
        }
        on_entity_removed_1.OnEntityRemoved.emit(this.eventService, entity);
        on_entity_removed_1.OnEntityRemoved.emit(this.chartEventService, entity);
    }
    addToGroup(entity, group, options) {
        DEBUG_MODE && rc_js_util_1._Debug.assert(this.entities.has(entity), "entity must be added before adding a trait");
        const added = rc_js_util_1.DirtyCheckedUniqueCollection.mapInitializeAdd(this.entitiesByGroup, group, entity);
        rc_js_util_1._Map.addToSet(this.groupsByEntities, entity, group);
        if (added) {
            group.onEntityAdded(entity, options);
            on_entity_added_to_group_1.OnEntityAddedToGroup.emit(this, entity, group);
        }
        return added;
    }
    removeFromGroup(entity, group) {
        rc_js_util_1._Map.deleteFromSet(this.groupsByEntities, entity, group);
        const removed = rc_js_util_1._Map.deleteFromSet(this.entitiesByGroup, group, entity);
        if (removed) {
            group.onEntityRemoved(entity);
            on_entity_removed_from_group_1.OnEntityRemovedFromGroup.emit(this, entity, group);
        }
        return removed;
    }
    getEntitiesInGroup(trait) {
        const entitiesByAncillaryObject = this.entitiesByGroup.get(trait);
        if (entitiesByAncillaryObject == null) {
            return rc_js_util_1._Array.emptyArray;
        }
        return entitiesByAncillaryObject.getArray();
    }
}
exports.Plot = Plot;
//# sourceMappingURL=plot.js.map